export const STOP_LOADING_PARENT = "STOP_LOADING_PARENT";
export const GET_PARENT_DATA = "GET_PARENT_DATA";
export const SET_PARENT_DATA = "SET_PARENT_DATA";
export const SET_CURRENT_PARENT = "SET_CURRENT_PARENT";
export const EDIT_PARENT = "EDIT_PARENT";
